<template>
    <v-btn @click="dialog = !dialog" color="green" dark>
        Tạo phiếu đăng ký
        <v-dialog v-model="dialog" max-width="90%">
            <app-card>
                <app-section-loader :status="loading.submit"></app-section-loader>
                <h4>PHIẾU ĐĂNG KÝ INTERNET</h4>
                <p class="fs-14 grey--text">Tạo phiếu đăng ký internet</p>
                <v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 md4>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="form.building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    :rules="[rules.required]"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-autocomplete
                                    label="Số phòng"
                                    :disabled="loading.submit"
                                    v-model="form.room_id"
                                    :items="room_ids"
                                    item-text="room_id"
                                    item-value="rooms_id"
                                    prepend-icon="meeting_room"
                                    :rules="[rules.required]"
                                    required
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field
                                    label="Giá thu khách hàng"
                                    :disabled="loading.submit"
                                    v-model="form.customer_price"
                                    prepend-icon="money"
                                    :rules="[rules.required]"
                                    v-currency
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Số người ở"
                                    :disabled="loading.submit"
                                    v-model="form.number_of_residents"
                                    prepend-icon="people"
                                    type="number"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Số chứng từ giấy"
                                    :disabled="loading.submit"
                                    v-model="form.receipt_code"
                                    prepend-icon="receipt"
                                    :rules="[rules.required]"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Mã chứng từ"
                                    :disabled="true"
                                    v-model="form.receipt_id"
                                    prepend-icon="receipt_long"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu_registration_date"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <v-text-field
                                        slot="activator"
                                        v-model="form.registration_date"
                                        label="Ngày đăng ký"
                                        :disabled="loading.submit"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker locale="vi-VI" v-model="form.registration_date" @input="menu_registration_date = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md12>
                                <v-text-field
                                    label="Phương án lắp đặt"
                                    :disabled="loading.submit"
                                    v-model="form.installation_plan"
                                    prepend-icon="build"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="loading.submit"
                            @click="cancelInput"
                        >
                            Trở về
                        </v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="green"
                            dark
                        >
                            Tạo Phiếu
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </app-card>
        </v-dialog>
    </v-btn>
</template>
<script>
import api from "Api";
import { list_building } from 'Constants/db-config';
import { parseCurrency } from "Helpers";
const basements = [
	{ room_id: 'tang-ham-gb', building: "GB"},
	{ room_id: 'tang-ham-tt', building: "TT"},
	{ room_id: 'tang-ham-ma', building: "MA"},
	{ room_id: 'tang-ham-xa', building: "XA"},
	{ room_id: 'tang-ham-bn', building: "BN"},
]

export default {
    name: "register-internet",
    data(){
        return {
            dialog: false,
            menu_registration_date: false,
            menu_date_start: false,
			rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            form: {
                building: '',
                room_id: '',
                customer_price: '',
                number_of_residents: 1,
                installation_plan: '',
                registration_date: '',
                note: '',
                receipt_code: '',
                receipt_id: ''
            },
            list_building,
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            loader: false,
            loading: {
                submit: false
            }
        }
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms.concat(basements)
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
        }
    },
    watch: {
        dialog(nv){
            if (!nv) this.$refs.form.reset();
        },
        "form.receipt_code"(nv) {
            if (nv && this.form.building) {
                const buildingCode = this.form.building === 'MT' ? 'MA' : this.form.building;
                this.form.receipt_id = buildingCode + '.' + nv + ".MA";
            }
        },
        "form.building"(nv) {
            if (nv && this.form.receipt_code) {
                const buildingCode = nv === 'MT' ? 'MA' : nv;
                this.form.receipt_id = buildingCode + '.' + this.form.receipt_code + ".MA";
            }
        }
    },
    methods: {
        cancelInput(){
            this.dialog = false
            this.$refs.form.reset();
        },
        async submit(){
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            try {
                const postData = {
                    ...this.form,
                    customer_price: parseCurrency(this.form.customer_price, "vi-VN", 'VND'),
                    number_of_residents: this.form.number_of_residents ? Number(this.form.number_of_residents) : 1,
                    registration_date: this.form.registration_date || new Date().toISOString().substr(0, 10),
                    note: this.form.note || '',
                    receipt_code: this.form.receipt_code,
                    receipt_id: this.form.receipt_id
                }
                this.loading.submit = true;
                console.log(postData);
                const data = await api.registerInternet(postData)
                this.loading.submit = false;
                if (data.status === 200) {
                    swal.fire('Thành công', data.message || 'Tạo phiếu đăng ký Internet thành công', 'success');
                    this.dialog = false;
                    this.$emit('reloadTable');
                } else {
                    swal.fire('Lỗi', data.message || 'Có lỗi xảy ra khi tạo phiếu', 'error');
                }
            } catch (error) {
                this.loading.submit = false;
                console.error("Submit error:", error);
                swal.fire('Lỗi', error.message || 'Có lỗi xảy ra khi tạo phiếu', 'error');
            }
        }
    }
}
</script>